import { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import { FaCheck, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import BasicInput from "../edittext/basicInput/basicInput";
import "./ProductForm.css"; // استایل سفارشی

import LinearLayout from "../layout/LinearLayout";
import ButtonSimp from "../button";
import FileInput from "../edittext/fileInput/fileInput";
import SelectBox from "../edittext/selectbox/SelectBox";

import BootImage from "../Image/bootImg/bootImg";
import Badge from "../badge/badge";
import KeywordsInput from "../edittext/KeywordsInput";

const ProductForm = ({
  product,
  onClose,
  onSuccess,
  categories = [],
  brands = [],
}) => {
  const [productState, setProduct] = useState(product || {});
  const [categoryAttributes, setCategoryAttributes] = useState([]);
  const [productAttributes, setProductAttributes] = useState([]);
  const [keywords, setKeywords] = useState(product?.keywords);
  const [title, setTitle] = useState(product?.title || "");
  const [slug, setSlug] = useState(product?.slug || "");
  const [productId, setProductId] = useState(product?._id || "");
  const [description, setDescription] = useState(product?.description || "");
  const [price, setPrice] = useState(product?.price || 0);
  const [discount, setDiscount] = useState(product?.discount || 0);
  const [stock, setStock] = useState(product?.stock || 0);
  const [color, setColor] = useState(product?.color || "");
  const [size, setSize] = useState(product?.size || "");
  const [brand, setBrand] = useState(product?.brand || "");
  const [categoryId, setCategoryId] = useState(product?.categoryId || "");
  const [brandId, setBrandId] = useState(product?.categoryId || "");
  const [images, setImages] = useState(product?.images || []);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [addingBrand, setAddingBrand] = useState(false);
  const [newBrandName, setNewBrandName] = useState("");
  const [brandFile, setBrandFile] = useState(null);
  const [brandImageUrl, setBrandImageUrl] = useState(""); // مسیر عکس آپلود شده

  // console.log("brand=", brands);
  if (selectedCategory) {
    const categoryid = categories.find((cat) => cat.name === selectedCategory);
  }
  const handleBrandFileChange = (e) => {
    setBrandFile(e.target.files[0]);
  };

  const getbrand = (brand) => {
    console.log("brand=", brand);
  };
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]); // فایل انتخاب‌شده ذخیره میشه
  };
  const getCategoryTitle = (categoryId, catarr) => {
    const category = catarr.find((cat) => cat._id === categoryId);

    return category ? category.name : "-";
  };
  const geturlimage = (img) => {
    console.log("imgurl1", img);
  };
  useEffect(() => {
    if (product) {
      setTitle(product.title || "");
      setProductId(product._id || "");
      setKeywords(product.keywords || "");
      setSlug(product.slug || "");
      setDescription(product.description || "");
      setPrice(product.price || 0);
      setDiscount(product.discount || 0);
      setStock(product.stock || 0);
      setColor(product.color || "");
      setSize(product.size || "");
      setBrand(product.brand || "");
      setCategoryId(product.categoryId || "");
      setBrandId(product.brand || "");
      setImages(product.images || []);
    } else {
      // اگر محصول null بود (حالت افزودن)، مقادیر رو ریست کن
      setTitle("");
      setProductId("");
      setKeywords("");
      setSlug("");
      setDescription("");
      setPrice(0);
      setDiscount(0);
      setStock(0);
      setColor("");
      setSize("");
      setBrand("");
      setCategoryId("");
      setBrandId("");
      setImages([]);
    }
  }, [product]);
  const handleAddProduct = async () => {
    const productData = {
      title,
      slug,
      description,
      price,
      discount,
      stock,
      color,
      size,
      brand,
      categoryId,
      images,
      keywords,
    };

    try {
      const res = await axios.post("/products", productData);
      // console.log("محصول با موفقیت افزوده شد:", res.data);
      onSuccess(); // مثلاً بستن فرم یا بروزرسانی لیست
    } catch (error) {
      // console.error("خطا در افزودن محصول:", error);
      alert("There was an error adding the product.");
    }
  };
  useEffect(() => {
    if (!categoryId) return;

    axios.get(`/categories/${categoryId._id}`).then((res) => {
      const attrs = res.data.data.attributes || [];

      setCategoryAttributes(attrs);

      setProductAttributes(
        attrs.map((attr) => {
          // اگر محصول attribute داره، مقدار قبلی رو بذار
          const existing = product?.attributes?.find(
            (a) => a.name === attr.name
          );
          return {
            name: attr.name,
            value: existing ? existing.value : "",
          };
        })
      );
    });
  }, [categoryId, product]);

  const handleAttributeChange = (index, newValue) => {
    setProductAttributes((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], value: newValue };
      return updated;
    });
  };

  const handleUpdateProduct = async () => {
    const productData = {
      title,
      slug,
      description,
      price: Number(price),
      discount: Number(discount),
      stock: Number(stock),
      color,
      size,
      brand: brand === "" ? null : brand,
      categoryId: categoryId === "" ? null : categoryId,
      images,
      keywords,
      attributes: productAttributes,
    };

    try {
      const res = await axios.put(`/products/${product._id}`, productData);
      // console.log("محصول ویرایش شد:", res.data);
      onSuccess();
    } catch (error) {
      // console.error("خطا در ویرایش محصول:", error);
      alert("An error occurred while editing the product.");
    }
  };
  // const handleBrandUpload = async () => {
  //   if (!brandFile) return;
  //   const formData = new FormData();
  //   formData.append("image", brandFile);

  //   try {
  //     const res = await axios.post("/brands/upload-image", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //     setBrandImageUrl(res.data.url); // مسیر عکس برند ذخیره میشه
  //   } catch (err) {
  //     console.error("خطا در آپلود تصویر برند:", err);
  //     alert("آپلود تصویر برند با خطا مواجه شد");
  //   }
  // };

  const handleDeleteImage = (imgUrl) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    axios
      .delete("/products/delete-image", {
        data: {
          productId: product._id,
          imageUrl: imgUrl,
        },
      })
      .then((res) => {
        setProduct(res.data.product); // اطلاعات جدید از سرور
        setImages(res.data.product.images);
      })

      .catch((err) => {
        // console.error("خطا در حذف تصویر:", err);
        alert("An error occurred while deleting the image.");
      });
  };
  const handleUploadBrand = async () => {
    if (!brandFile) return;
    const formData = new FormData();
    formData.append("image", brandFile);
    formData.append("brandId", brandId);

    axios
      .post("/brands/upload-image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Image uploaded:", res.data);
        setBrandImageUrl(res.data.url); // اینجا دیگه آرایه نمیسازیم
      })
      .catch((err) => {
        console.error("Upload error:", err);
      });
  };
  const handleUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("image", selectedFile); // فایلی که کاربر انتخاب کرده
    formData.append("productId", product._id); // آیدی محصول مورد نظر

    axios
      .post("/products/upload-image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Image uploaded:", res.data);
        setImages((prev) => [...prev, res.data.url]);
      })
      .catch((err) => {
        console.error("Upload error:", err);
      });
  };
  const handleSubmit = () => {
    if (product?._id) {
      handleUpdateProduct();
    } else {
      handleAddProduct();
    }
    const handleAttributeChange = (index, value) => {
      const updatedAttributes = [...productAttributes];
      updatedAttributes[index].value = value;
      setProductAttributes(updatedAttributes);
    };
  };
  return (
    <LinearLayout
      bgcolor="white"
      orientation="vertical"
      height="match-parent"
      width="match-parent"
      className="product-form-container"
    >
      <h4 className="form-title">{product ? "Edit Product" : "Add Product"}</h4>

      {/* 🧩 بخش اطلاعات اصلی */}
      <h5 className="form-section">Basic Information</h5>
      <LinearLayout orientation="horizontal" className="form-row">
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Title"
          value={title}
          onChange={setTitle}
        />
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Slug"
          value={slug}
          onChange={setSlug}
        />
        <KeywordsInput
          value={keywords} // state آرایه
          onChange={setKeywords}
          margin="2"
          bgcolor="white"
          bcolor="primary"
          textcolor="black"
          text="Keywords"
        />
      </LinearLayout>
      <LinearLayout>
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Description"
          value={description}
          onChange={setDescription}
        />
        <SelectBox
          value={categoryId}
          onChange={setCategoryId}
          array={categories}
          text="Category"
          bcolor="primary"
          textcolor="dark"
          bgcolor="white"
          margin="2"
        />
      </LinearLayout>

      <hr />

      {/* 💰 بخش قیمت و انبار */}
      <h5 className="form-section">Price And Inventory</h5>
      <LinearLayout orientation="horizontal" className="form-row">
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Price"
          value={price}
          onChange={setPrice}
        />
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Discount"
          value={discount}
          onChange={setDiscount}
        />
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Stock"
          value={stock}
          onChange={setStock}
        />
      </LinearLayout>

      <hr />

      {/* ⚙️ ویژگی‌ها */}
      <h5 className="form-section">Category Attribute</h5>
      <LinearLayout
        orientation="vertical"
        xgravity="start"
        ygravity="start"
        width="match-parent"
        height="wrap-content"
        className="pe-md-5"
      >
        {categoryAttributes.map((attr, index) => {
          if (attr.type === "select") {
            return (
              <LinearLayout
                width="match-parent"
                orientation="horizontal"
                className="form-row pe-md-5"
              >
                <SelectBox
                  className="me-md-5"
                  key={index}
                  value={productAttributes[index]?.value || ""}
                  onChange={(value) => handleAttributeChange(index, value)}
                  array={attr.options}
                  text={attr.name}
                  name=""
                  bcolor="primary"
                  textcolor="dark"
                  bgcolor="white"
                  margin="2"
                />
              </LinearLayout>
            );
          } else if (attr.type === "boolean") {
            return (
              <LinearLayout
                key={index}
                width="match-parent"
                orientation="horizontal"
                className="form-row pe-md-5"
              >
                <SelectBox
                  className="me-md-5"
                  value={productAttributes[index]?.value || "No"}
                  onChange={(value) => handleAttributeChange(index, value)}
                  array={[
                    { _id: "Yes", name: "Yes" },
                    { _id: "No", name: "No" },
                  ]}
                  text={attr.name}
                  name=""
                  bcolor="primary"
                  textcolor="dark"
                  bgcolor="white"
                  margin="2"
                />
              </LinearLayout>
            );
          } else {
            return (
              <LinearLayout
                width="match-parent"
                orientation="horizontal"
                className="form-row pe-md-5"
              >
                <BasicInput
                  className="me-md-5"
                  key={index}
                  bsize="1"
                  bcolor="primary"
                  margin="2"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text={attr.name}
                  value={productAttributes[index]?.value || ""}
                  onChange={(value) => handleAttributeChange(index, value)}
                />
              </LinearLayout>
            );
          }
        })}
      </LinearLayout>

      <h5 className="form-section">Technical Features</h5>
      <LinearLayout orientation="vertical" className="form-row">
        <LinearLayout orientation="horizontal" justify="end">
          <BasicInput
            bsize="1"
            bcolor="primary"
            margin="2"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="Color"
            value={color}
            onChange={setColor}
          />
          <BasicInput
            bsize="1"
            bcolor="primary"
            margin="2"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="Size"
            value={size}
            onChange={setSize}
          />
        </LinearLayout>
        <LinearLayout orientation="horizontal" className="form-row">
          <SelectBox
            value={brandId}
            onChange={(value) => {
              if (value === "__new__") {
                setAddingBrand(true);
              } else {
                setBrandId(value);
                setBrand(value);
                setAddingBrand(false);
              }
            }}
            array={[{ _id: "__new__", name: "+ Add New Brand" }, ...brands]}
            text={"Brand"}
            bcolor="primary"
            textcolor="dark"
            bgcolor="white"
            margin="2"
          />
          {brandId && (
            <LinearLayout
              orientation="vertical"
              margin={2}
              className="form-row"
            >
              <FileInput
                bsize="2"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                handleFileChange={handleBrandFileChange}
                handleUpload={handleUploadBrand}
              />
              {brandImageUrl && (
                <img
                  src={`${brandImageUrl}`}
                  alt="brand preview"
                  style={{ width: 80, height: 80, objectFit: "contain" }}
                />
              )}
            </LinearLayout>
          )}
          {addingBrand && (
            <LinearLayout
              bgcolor="white"
              height="match-parent"
              width="match-parent"
              orientation="vertical"
              className="brand-add-section"
            >
              <LinearLayout orientation="horizontal" className="form-row">
                <BasicInput
                  bsize="1"
                  bcolor="primary"
                  margin="2"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text="New Brand Name"
                  value={newBrandName}
                  onChange={setNewBrandName}
                />
              </LinearLayout>

              {/* 🖼️ آپلود تصویر برند */}

              <LinearLayout orientation="horizontal" className="form-row">
                <ButtonSimp
                  margin="0"
                  size="sm"
                  font="0"
                  color="success"
                  padding="1"
                  text=""
                  clicked={async () => {
                    if (!newBrandName.trim()) {
                      alert("Enter the new brand name.");
                      return;
                    }
                    try {
                      const res = await axios.post("/brands", {
                        name: newBrandName,
                        image: brandImageUrl, // 👈 تصویر برند
                      });
                      setBrandId(res.data._id);
                      setBrand(res.data);
                      setNewBrandName("");
                      setBrandImageUrl("");
                      setAddingBrand(false);
                      brands.push(res.data);
                    } catch (error) {
                      alert("Error adding brand");
                    }
                  }}
                >
                  <FaCheck />
                </ButtonSimp>
                <ButtonSimp
                  margin="0"
                  size="sm"
                  font="0"
                  color="danger"
                  padding="1"
                  text=""
                  clicked={() => setAddingBrand(false)}
                >
                  <FaTimes />
                </ButtonSimp>
              </LinearLayout>
            </LinearLayout>
          )}
        </LinearLayout>
      </LinearLayout>

      <hr />

      {/*  تصویر محصول */}
      <h5 className="form-section">Product Image</h5>
      <LinearLayout orientation="vertical" className="form-row">
        <FileInput
          bsize="2"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          handleFileChange={handleFileChange}
          handleUpload={handleUpload}
        />
        {images.length > 0 && (
          <div className="image-preview">
            {images.map((img, index) => (
              <BootImage
                key={index}
                margin="1"
                padding="0"
                src={`${img}`}
                type="rounded"
                alt={`uploaded-${index}`}
              >
                <Badge
                  top="5px"
                  start="203px"
                  color="danger"
                  text={<FaTimes className="mb-1" />}
                  onClick={() => handleDeleteImage(img)}
                />
              </BootImage>
            ))}
          </div>
        )}
      </LinearLayout>

      <hr />

      {/* 🎯 دکمه‌ها */}
      <LinearLayout orientation="horizontal" justify="end">
        <ButtonSimp
          margin="2"
          size="md"
          font="6"
          color="danger"
          padding="2"
          paddingtop="1"
          text="Cancel"
          clicked={onClose}
        />
        <ButtonSimp
          margin="2"
          size="md"
          font="6"
          color="primary"
          padding="2"
          paddingtop="1"
          text="Submit"
          clicked={handleSubmit}
        />

        <Link to={`/product/${productId}`} className="cart-icon">
          <ButtonSimp
            margin="2"
            size="md"
            font="6"
            color="success"
            padding="2"
            paddingtop="1"
            text="Product Page"
          />
        </Link>
      </LinearLayout>
    </LinearLayout>
  );
};

export default ProductForm;
// <LinearLayout
//   bgcolor="white"
//   orientation="vertical"
//   height="match-parent"
//   width="match-parent"
//   className="overflow-auto"
// >
//   <h4>{product ? "Edit Product" : "Add Product"}</h4>
//   <LinearLayout
//     bgcolor="white"
//     orientation="horizontal"
//     height="match-parent"
//     width="match-parent"
//     className="overflow-auto"
//   >
//     <h4></h4>
//     <LinearLayout
//       bgcolor="white"
//       orientation="vertical"
//       height="match-parent"
//       width="match-parent"
//       className="overflow-auto"
//     >
//       <SelectBox
//         name=""
//         value={categoryId}
//         onChange={(val) => setCategoryId(val)}
//         array={categories}
//         margin="2"
//         bcolor="primary"
//         textcolor="dark"
//         bgcolor="white"
//         text="Category"
//       />

//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Title"
//         value={title}
//         onChange={setTitle}
//       />

//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Slug"
//         value={slug}
//         onChange={setSlug}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Description"
//         value={description}
//         onChange={setDescription}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Price"
//         value={price}
//         onChange={setPrice}
//       />
//     </LinearLayout>
//     <LinearLayout
//       bgcolor="white"
//       orientation="vertical"
//       height="match-parent"
//       width="match-parent"
//       className="overflow-auto"
//     >
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Discount"
//         value={discount}
//         onChange={setDiscount}
//       />

//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Stock"
//         value={stock}
//         onChange={setStock}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Color"
//         value={color}
//         onChange={setColor}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Size"
//         value={size}
//         onChange={setSize}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Brand"
//         value={brand}
//         onChange={setBrand}
//       />
//     </LinearLayout>
//   </LinearLayout>
//   <FileInput
//     bsize="2"
//     bcolor="primary"
//     margin="2"
//     bgcolor="white"
//     textcolor="black"
//   />
//   <LinearLayout
//     bgcolor="white"
//     orientation="horizontal"
//     height="match-parent"
//     width="match-parent"
//     className="overflow-auto"
//   >
//     <ButtonSimp
//       margin="2"
//       size="md"
//       font="6"
//       color="danger"
//       padding="2"
//       text="Cancel"
//       clicked={onClose}
//     />
//     <ButtonSimp
//       margin="2"
//       size="md"
//       font="6"
//       color="primary"
//       padding="2"
//       text="Submit"
//       clicked={handleSubmit}
//     />
//   </LinearLayout>
// </LinearLayout>

// <div className="modal-container">
//   <div className="modal-content">
//     <h2>{product ? "ویرایش محصول" : "افزودن محصول جدید"}</h2>

//     <div className="form-section">
//       <h4>اطلاعات کلی</h4>
//       <div className="grid">
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="عنوان محصول"
//           value={title}
//           onChange={setTitle}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="نامک (slug)"
//           value={slug}
//           onChange={setSlug}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="توضیحات"
//           value={description}
//           onChange={setDescription}
//         />
//       </div>
//     </div>

//     <div className="form-section">
//       <h4>مشخصات فروش</h4>
//       <div className="grid">
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="قیمت"
//           value={price}
//           onChange={setPrice}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="تخفیف (%)"
//           value={discount}
//           onChange={setDiscount}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="موجودی"
//           value={stock}
//           onChange={setStock}
//         />
//       </div>
//     </div>

//     <div className="form-section">
//       <h4>ویژگی‌ها</h4>
//       <div className="grid">
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="رنگ"
//           value={color}
//           onChange={setColor}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="سایز"
//           value={size}
//           onChange={setSize}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="برند"
//           value={brand}
//           onChange={setBrand}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="کد دسته‌بندی"
//           value={categoryId}
//           onChange={setCategoryId}
//         />
//       </div>
//     </div>

//     <div className="form-section">
//       <h4>تصاویر محصول</h4>
//       <div className="image-upload-box">
//         <input
//           type="file"
//           onChange={(e) => setSelectedFile(e.target.files[0])}
//         />
//         <button className="upload-btn" onClick={handleImageUpload}>
//           آپلود تصویر
//         </button>
//       </div>
//       <div className="image-preview">
//         {images.map((img, i) => (
//           <img key={i} src={img} alt="product" />
//         ))}
//       </div>
//     </div>

//     <div className="modal-actions">
//       <button className="save-btn" onClick={handleSubmit}>
//         ذخیره
//       </button>
//       <button className="cancel-btn" onClick={onClose}>
//         لغو
//       </button>
//     </div>
//   </div>
// </div>
// console.log("category =", categories);
// const handleUpload = async (event) => {
//   const formData = new FormData();
//   formData.append("image", event.target.files[0]);

//   try {
//     const response = await fetch(
//       process.env.REACT_APP_API_BASE_URL+"/products/upload-image",
//       {
//         method: "POST",
//         body: formData,
//       }
//     );

//     const data = await response.json();
//     console.log("Image URL:", data.url);
//   } catch (error) {
//     console.error("Upload failed:", error);
//   }
// };
// const handleUpload = async () => {
//   if (!selectedFile) return;
//   const formData = new FormData();
//   formData.append("image", selectedFile);

//   try {
//     const { data } = await axios.post("/products/upload-image", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     setImages((prev) => [...prev, data.url]);
//   } catch (err) {
//     console.error("خطا در آپلود تصویر", err);
//   }
// };

// const handleSubmit = async () => {
//   const productData = {
//     title,
//     slug,
//     description,
//     price,
//     discount,
//     stock,
//     color,
//     size,
//     brand,
//     categoryId,
//     images,
//   };

//   try {
//     if (product?._id) {
//       await axios.put(`/api/products/${product._id}`, productData);
//     } else {
//       await axios.post("/api/products", productData);
//     }
//     onSave();
//   } catch (err) {
//     console.error("خطا در ذخیره‌سازی محصول", err);
//   }
// };

